import type { Quiz } from "./_schema";
import { quizBeforeTrtQuiz } from "./quiz-before-trt";
import { cortisolQuiz } from "./cortisol";
import { igniteQuiz } from "./ignite";
import { quizGlpQuiz } from "./quiz-glp";
import { quizV7Quiz } from "./quiz-v7";
import { tCalcQuiz } from "./t-calc";
import { quizTrtSwitchQuiz } from "./quiz-trt-switch";

// `free-t` is intentionally NOT registered as a public slug. The free-t quiz
// implementation in `quizzes/free-t.ts` is the canonical Vermeulen calculator
// that `t-calc` inherits from (`tCalcQuiz.compute = freeTQuiz.compute`, etc.),
// but it has no live Shopify page and is not loadable via `?quiz=free-t`. If
// a future calculator wants to expose it as its own slug, add the entry back
// here and to `api/schemas/submission.py` (QUIZ_SLUGS + CALCULATOR_SLUGS).
export const quizRegistry: Record<string, Quiz> = {
  [igniteQuiz.slug]: igniteQuiz,
  [quizV7Quiz.slug]: quizV7Quiz,
  [tCalcQuiz.slug]: tCalcQuiz,
  [cortisolQuiz.slug]: cortisolQuiz,
  [quizGlpQuiz.slug]: quizGlpQuiz,
  [quizBeforeTrtQuiz.slug]: quizBeforeTrtQuiz,
  [quizTrtSwitchQuiz.slug]: quizTrtSwitchQuiz,
};
